/**
 * Extracts a sortable last name from a full name.
 *
 * Rules:
 * - Uses the last space-separated token as the last name
 *   e.g. "Keisha Lance Bottoms" → "Bottoms"
 * - For hyphenated last names, uses the first segment of the hyphen
 *   e.g. "Katherine Juhan-Arnold" → "Juhan"
 *
 * @param {string} fullName
 * @returns {string} The sortable last name, lowercased for comparison
 */
export const getSortableLastName = (fullName) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/);
  const lastPart = parts[parts.length - 1] || "";
  // If hyphenated, use the first segment
  const sortKey = lastPart.includes("-") ? lastPart.split("-")[0] : lastPart;
  return sortKey.toLowerCase();
};

/**
 * Sorts an array of candidate objects by last name (ascending, case-insensitive).
 * Does NOT mutate the original array.
 *
 * @param {Array<{name: string}>} candidates
 * @returns {Array<{name: string}>} A new sorted array
 */
export const sortCandidatesByLastName = (candidates) => {
  if (!Array.isArray(candidates)) return [];
  return [...candidates].sort((a, b) =>
    getSortableLastName(a.name).localeCompare(
      getSortableLastName(b.name),
      "en",
      { sensitivity: "base" }
    )
  );
};
